export default __webpack_public_path__ + "static/media/qr-bridge-stg.fffcf3f5.png";